import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState, useRef, useCallback, useContext } from "react";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "../../Common/useCommon";


export const useBucketConfigration = () => {
    const { showSuccess, showError } = useContext(ToastContext);
    const { getValuePermission } = useCommon()
    const [issueTypes, setIssueTypes] = useState([]);
    const [rowData, setRowData] = useState([]);
    const menuRef = useRef(null);
    const tagRef = useRef(null)
    const [selectedRow, setSelectedRow] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loader, setLoader] = useState(false);
    const isChange = useRef(null);
    const selectedRowRef = useRef(null);
    const [activeTab, setActiveTab] = useState({ index: 0, title: "Category Wise", value: "category" });
    const tabs = [
        { index: 0, title: "Category Wise", value: "category" },
        { index: 1, title: "Role Wise", value: "role" }
    ]

    const columns = [
        {
            key: "category_name",
            label: "Category",
            style: { width: "15%" },
            hide: activeTab?.value !== "category",
            render: (row) => (
                <div className=" text-truncate" title={row?.category_name}> {row?.category_name}</div>
            )
        },
        {
            key: "project_role_name",
            label: "Role",
            style: { width: "15%" },
            hide: activeTab?.value !== "role",
            render: (row) => (
                <div className=" text-truncate" title={row?.project_role_name}> {row?.project_role_name}</div>
            )
        },
        {
            key: "issue_types",
            label: "Assigned Issue Types",
            style: { width: getValuePermission("bucket_config_action_btn") ? "85%" : "75%" },
            sort: false,
            render: (row) => (
                <div className="d-flex gap-2 m-1 flex-wrap">
                    {_.sortBy(row?.issue_types, "issue_type_name")?.map((value, index) => (
                        value.issue_type_name && <div
                            key={index}
                            className="round-small-section"
                            
                        >
                            {value.issue_type_name}
                        </div>
                    ))}
                </div>
            ),
        },
        {
            key: "action",
            label: "Action",
            style: { width: "10%"},
            headerStyle: { textAlign: "center" },
            hide: getValuePermission("bucket_config_action_btn"),
            sort: false,
            render: (row) => (
                <div className="d-flex justify-content-center align-items-center mx-2 my-1">
                    <button
                        className="sk-btn sk-btn-primary"
                        onClick={(e) => {
                            setSelectedRow(row);
                            setSearchTerm('');
                            menuRef.current?.toggle(e);
                        }}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-gear" className="me-1" /> Manage
                    </button>
                </div>
            )
        },
    ];

    const getIssueTypeName = useCallback((issueType) => {
        return typeof issueType === 'object'
            ? (issueType.issue_type_name || issueType.issue_type_id || issueType.toString())
            : issueType;
    }, []);

    const isIssueTypeSelected = useCallback((row, issueType) => {
        const rowTypes = row?.issue_types || [];
        return rowTypes.some(type => {
            if (typeof type === 'object' && typeof issueType === 'object') {
                return type.issue_type_id === issueType.issue_type_id;
            }
            return getIssueTypeName(type) === getIssueTypeName(issueType);
        });
    }, [getIssueTypeName]);

    const updateRowIssueTypes = (row, newIssueTypes) => {
        const updatedRowData = rowData.map(group => ({
            ...group,
            children: group.children.map(child =>
                child.id === row.id
                    ? { ...child, issue_types: newIssueTypes }
                    : child
            )
        }));

        setRowData(updatedRowData);
        isChange.current = true
        selectedRowRef.current = updatedRowData[0]?.children.find(child => child.id === row.id);
    };

    const getMenuItems = (row) => {
        const data = _.find(rowData[0]?.children, { id: row?.id })
        const filteredIssueTypes = issueTypes.filter(issueTypeObj => {
            const issueTypeName = getIssueTypeName(issueTypeObj);
            return issueTypeName.toLowerCase().includes(searchTerm.toLowerCase());
        });
        return [
            {
                key: 'header',
                template: () => (
                    <div className="px-1 position-fixed bg-white mb-2 border-bottom" style={{ width: "200px" }}>
                        <div className="d-flex gap-1 align-items-center w100">
                            <span className="">
                                <i className="pi pi-search" />
                            </span>
                            <input
                                type="text"
                                className=""
                                placeholder="Filter issue types..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                }}
                                onMouseDown={(e) => {
                                    e.stopPropagation();
                                }}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                )
            },
            ...(filteredIssueTypes.length === 0 ? [{
                key: 'no-results',
                template: () => (
                    <div className="p-3 text-center text-muted">
                        No issue types found matching "{searchTerm}"
                    </div>
                )
            }] : filteredIssueTypes.map((issueTypeObj, index) => ({
                key: `issue-${issueTypeObj.issue_type_id || getIssueTypeName(issueTypeObj)}`,
                template: () => {
                    const issueTypeName = getIssueTypeName(issueTypeObj);
                    const isChecked = isIssueTypeSelected(data, issueTypeObj);
                    return (
                        <div
                            className={`d-flex gap-2 align-items-center px-1 c-pointer ${index === 0 && "mt-4"} `}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const currentTypes = data.issue_types || [];
                                let newTypes;
                                if (isChecked) {
                                    newTypes = currentTypes.filter(type => {
                                        if (typeof type === 'object' && typeof issueTypeObj === 'object') {
                                            return type.issue_type_id !== issueTypeObj.issue_type_id;
                                        }
                                        return getIssueTypeName(type) !== getIssueTypeName(issueTypeObj);
                                    });
                                } else {
                                    newTypes = [...currentTypes, issueTypeObj];
                                }
                                updateRowIssueTypes(data, newTypes);

                            }}

                        >
                            <FontAwesomeIcon icon="fa-solid fa-check" className={`${isChecked ? "visible" : "invisible"}`} />
                            <span className="flex-1">{issueTypeName}</span>
                        </div>
                    );
                }
            })))
        ];


    }

    useEffect(() => {
        callautopopulate("agile_issue_type").then(res => {
            const types = res?.agile_issue_type || [];
            setIssueTypes(_.sortBy(types, "issue_type_name"));
        });
    }, []);


    useEffect(() => {

        if (activeTab?.value === "category") {
            getIssueTypeMappingList()
        } else if (activeTab?.value === "role") {
            getIssueTypeRoleMappingList()
        }
        selectedRowRef.current = null
    }, [activeTab])


    const getIssueTypeMappingList = async () => {
        try {
            setLoader(true)
            const res = await services.getInvokeRemote("GET", Urls("GETISSUETYPETEAMCATEGORYMAPPINGLIST"))
            if (!res?.body?.error_status) {
                setRowData([
                    {
                        title: "",
                        id: "all",
                        children: res?.body?.data?.map(obj => ({
                            ...obj,
                            id: obj?.category_id,
                            issue_types: obj?.issue_type_detail || []
                        }))
                    }
                ])
            } else {
                setRowData([])
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error)
        }
    }

    const getIssueTypeRoleMappingList = async () => {
        try {
            setLoader(true)
            const res = await services.getInvokeRemote("GET", Urls("GETISSUETYPEROLEMAPPINGLIST"))
            if (!res?.body?.error_status) {
                setRowData([
                    {
                        title: "",
                        id: "all",
                        children: res?.body?.data.map(obj => ({
                            ...obj,
                            id: obj?.project_role_id,
                            issue_types: obj?.issue_type_detail || []
                        }))
                    }
                ])
            } else {
                setRowData([])
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error(error)
        }
    }


    const handleUpsertIssueType = async () => {
        try {
            if (!isChange.current) {
                return null
            }
            setLoader(true);
            let url;
            let payload;
            if (activeTab?.value === "role") {
                url = "UPSERTISSUETYPEROLEMAPPINGDETAIL"
                payload = {
                    project_role_id: selectedRowRef?.current?.project_role_id,
                    issue_type_ids: _.pluck(selectedRowRef?.current?.issue_types, "issue_type_id")?.toString() || ""
                };
            } else if (activeTab?.value === "category") {
                url = "UPSERTISSUETYPETEAMCATEGORYMAPPINGDETAIL"
                payload = {
                    category_id: selectedRowRef?.current?.category_id,
                    issue_type_ids: _.pluck(selectedRowRef?.current?.issue_types, "issue_type_id")?.toString() || ""
                };
            }
            const res = await services.getInvokeRemote("POST", Urls(url), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                if (activeTab?.value === "category") {
                    getIssueTypeMappingList();
                } else if (activeTab?.value === "role") {
                    getIssueTypeRoleMappingList();
                }
            } else {
                showError("error", res.body.errorMessage)
            }
            setLoader(false)
            isChange.current = false
        } catch (error) {
            setLoader(false)
            console.error(error);
        }
    }

    return useMemo(() => ({
        columns, rowData, menuRef, selectedRow, getMenuItems, handleUpsertIssueType, loader, activeTab, setActiveTab, tabs, isChange, tagRef
    }), [columns, rowData, selectedRow, getMenuItems, handleUpsertIssueType, loader, activeTab, setActiveTab, tabs, isChange, tagRef]);
}
